module.exports = __webpack_public_path__ + "pc/img/ad01.930acfa8.png";